"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.ViewMoreLoader = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = require("../Button");
var Container_1 = require("../Container");
var ViewMoreError_1 = require("./ViewMoreError");
var ViewMoreLoader = function (_a) {
    var load = _a.load, label = _a.label, autoload = _a.autoload, error = _a.error, isLoading = _a.isLoading, hasReachedEnd = _a.hasReachedEnd, className = _a.className, rest = __rest(_a, ["load", "label", "autoload", "error", "isLoading", "hasReachedEnd", "className"]);
    react_1.useEffect(function () {
        if (autoload && !error && !isLoading && !hasReachedEnd) {
            load();
        }
    }, []);
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        error && (react_1["default"].createElement(ViewMoreError_1.ViewMoreError, __assign({ className: ['view-more-error', className] }, rest, error))),
        isLoading && (react_1["default"].createElement(Container_1.Container, __assign({ className: ['view-more-loader', 'loading', className] }, rest))),
        !isLoading && !hasReachedEnd && (react_1["default"].createElement(Button_1.Button, __assign({ type: "button", onClick: function () { return load(); }, className: ['view-more-btn', className] }, rest), label))));
};
exports.ViewMoreLoader = ViewMoreLoader;
//# sourceMappingURL=ViewMoreLoader.js.map